import React from 'react'
import UserProfile from 'containers/UserProfile'

export default function ProfilePage() {
  return <UserProfile />
}
